<template>
    <div class="slides__slide text intro grid-container">
        <div class="grid-x grid-padding-x align-center">
            <div class="cell medium-20 large-12">
                <div class="text-content">
                    <h1>{{ slidedata.title }}</h1>
                    <p>{{ slidedata.description }}</p>

                    <a href="#" class="btn" @click.prevent="restart()">{{ slidedata.button }}<i class="icon-arrow-right"></i></a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        slidedata: {
            default() {
                return {};
            },
            type: Object,
        },
        datamodel: {
            default() {
                return {};
            },
            type: Object,
        },
    },
    methods: {
        restart() {
            this.$emit('restart');
        },
    },
};
</script>
